import React from "react";
import {OrganizationData} from "../interface";
import {show_loader} from "./functions";
import axios from "axios";
import qs from 'qs';
declare var organization_data:OrganizationData;

export class OrgSubAccounts extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
        this.state = {
            action: 'fr_create_sub_account',
            req_nonce: organization_data.req_nonce,
            org_id: this.props.currOrganization,
            str_email: '',
            str_firstname: '',
            str_lastname: '',
            errors: '',
            message: '',
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit = (e:any) => {
        e.preventDefault();
        show_loader(true);

        axios.post( organization_data.admin_ajax, qs.stringify( this.state ) )
            .then( response => {
                console.log( response );
                if( response && response.data ) {
                    if( response.data.success ) {
                        const data = response.data;
                        if( data.success ) {
                            this.setState( {errors: ''} );
                            this.setState( {message: data.message} );
                        }
                    } else {
                        if( response.data.hasOwnProperty('errors') ) {
                            this.setState( {message: ''} );
                            this.setState({errors: response.data.errors});
                        }
                    }
                }
            } )
            .catch( error=>{
                console.log(error);
            } )
            .finally(() => {
                show_loader(false);
            })

        console.log( 'form submit', this.state );
    }

    handleInputChange = (e:any) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        const readonly_mode = (this.props.currOrganization===0);
        const disabled_mode = (this.props.currOrganization===0);

        return (
            <div className="organization_sub_account">
                <form onSubmit={this.onFormSubmit}>
                    <div className='org_sub_account_form'>
                        <div className='form--input-field'>
                            <label htmlFor='str_email'>Email</label>
                            <input type='email' value={this.state.str_email} onChange={this.handleInputChange} name='str_email' required readOnly={readonly_mode} disabled={disabled_mode} />
                        </div>
                        <div className='form--input-field'>
                            <label htmlFor='str_firstname'>First Name</label>
                            <input type='text' value={this.state.str_first_name} onChange={this.handleInputChange} name='str_firstname' required readOnly={readonly_mode} disabled={disabled_mode} />
                        </div>
                        <div className='form--input-field'>
                            <label htmlFor='str_lastname'>Last Name</label>
                            <input type='text' value={this.state.str_last_name} onChange={this.handleInputChange} name='str_lastname' required readOnly={readonly_mode} disabled={disabled_mode} />
                        </div>
                        { this.state.errors.length > 0 ?
                            <div className='form--error-field'>{this.state.errors}</div>
                            : <div></div>
                        }
                        { this.state.message.length > 0 ?
                            <div className='form--success-field'>{this.state.message}</div>
                            : <div></div>
                        }
                        <div className='form--input-field'>
                            <div className='form--btn-wrapper-fixed'>
                                <button className='submit--btn' type='submit' disabled={disabled_mode}>Create Sub Account</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}